import axios from 'axios'
import { Message ,MessageBox } from 'element-ui'

let baseURL = process.env.NODE_ENV === 'production' ? "/" : "/api";
axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = baseURL;

axios.interceptors.request.use(
  config => {
    try {
      const OS_DEVICE_INFO = JSON.parse(sessionStorage.getItem('OS_DEVICE_INFO'))
      Object.assign(config.headers, OS_DEVICE_INFO)
      } catch (e) {}
    return config
  },
  error => {
    Promise.reject(error)
  }
)

axios.interceptors.response.use(res => {
    let data = res.data || {};
    const configData = ((res || {}).config || {}).data
    let params = {}
    try {
      params = typeof configData === 'string' ? JSON.parse(configData || '{}') : (configData || {})
    } catch (error) {
      params = {}
    }
    const succ = data.succ === 'ok' || data.success
    
    if (!succ && !params.noFailMsg) {
      if(data.succ === 'login'){
        location.href = '/'
      }
      let msg = data.msg ? data.msg : "请求失败";
      if (msg === '当前门户用户不存在') {
        msg = '当前手机号在当前门户不存在，请使用当前手机号重新注册'
      }
      let content = '<div class="center fs21"><div><i class="el-icon-error"></i></div><div class="msg"><span>'+msg+'</span></div></div>'
      if(location.href.indexOf('manage')!=-1){
        MessageBox.alert(content,'温馨提示',{
          type:'error',
          dangerouslyUseHTMLString:true,
          iconClass:'error',
          customClass:'commonAlert',
          confirmButtonText:'知道了',
        })
      }else{
        Message({
          message:msg,
          type: 'error'
        });
      }
      return Promise.reject(data)
    }
    /* if (res.config.interceptor === false) {
      return res;
    } */
    return data;
  },
  error => {
    Message({
      message: "网络异常",
      type: 'error'
    });
    return Promise.reject(error)
  }
)
const apiTimeoutSetting = (url)=>{
    // 导出类接口超时配置为3分钟
    axios.defaults.timeout = url.endsWith('/export') ? 3*60*1000 : 30000
}
export default function fetchPost(url, params) {
  apiTimeoutSetting(url)
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.result || response.response);
      }, err => { 
        return reject(err);
      })
  })
}

export function fetchResPsot(url, params) {
  apiTimeoutSetting(url)
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response);
      }, err => { 
        return reject(err);
      })
  })
}

export function fetchGet(url, param) {
  apiTimeoutSetting(url)
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: param
    })
      .then(response => {
        resolve(response.result)
      }, err => {
        console.log('err',err)
        reject(err)
      })
  })
}


export function fetchPostFormData(url, params) {
  apiTimeoutSetting(url)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  try {
		const OS_DEVICE_INFO = JSON.parse(sessionStorage.getItem('OS_DEVICE_INFO'))
		Object.assign(config.headers, OS_DEVICE_INFO)
	  } catch (e) {}
  return new Promise((resolve, reject) => {
    axios.post(url, params, config)
      .then(response => {
        resolve(response.result);
      }, err => { 
        return reject(err);
      })
  })
}
